//带加载动态的ajax
import {doAjax} from './tools';
export default async function LoadAjax(url,param,options){
	return new Promise((resolve,reject)=>{
		var result =  doAjax(url,param ?param:null,this,options);
		
		result.then((data)=>{
			resolve(data);
		})
		.catch((error)=>{
			reject(error);
		});
		;
	});
		
};


